import { render, staticRenderFns } from "./SubmissionForm.vue?vue&type=template&id=7fb3fb99&scoped=true"
import script from "./SubmissionForm.vue?vue&type=script&lang=ts"
export * from "./SubmissionForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb3fb99",
  null
  
)

export default component.exports